module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_2.e586475c.jpg";